import { Box, BoxProps, Button, ButtonGroup, Container, Flex, Image, Text } from '@chakra-ui/react';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { routes } from '../../../../../../constants/routes';
import { socials } from '../../../../../../constants/social';
import { CDN_LOGO_URL, commonConfig, version } from '../../../../config';
import SocialLinks from '../../../Link/SocialLinks/SocialLinks';
import FooterMenu from './Menu/FooterMenu';

export type FooterProps = BoxProps;

const Footer = (props: BoxProps): ReactElement | null => {
  const { t } = useTranslation();
  return (
    <Box py={10} bgColor="gray.900" color="white" as="footer" data-testid="footer" {...props}>
      <Container maxW="container.2xl">
        <Flex w="100%" direction={{ base: 'column', lg: 'row' }} justify="space-between">
          <Box w={{ base: '100%', lg: '40%' }} my={6} mr={{ base: 0, lg: 12 }}>
            <Image
              src={`${CDN_LOGO_URL}/rumi-logo-white.svg`}
              alt={commonConfig.company.name}
              htmlWidth="844"
              htmlHeight="238"
              w="200px"
              h="auto"
              mb={4}
            />
            <Text color="gray.300" mb={12}>
              {t('footer.description')}
            </Text>
          </Box>
          <Flex
            direction={{ base: 'column', md: 'row' }}
            my={6}
            flexGrow={1}
            justifyContent="space-between"
          >
            <Flex
              direction={{ base: 'row', md: 'column' }}
              wrap="wrap"
              mx={{ base: 0, lg: 'auto' }}
              mt={-2}
              mb={{ base: 12, md: 0 }}
            >
              <FooterMenu />
            </Flex>
            <Box textAlign={{ base: 'left', md: 'right' }}>
              <Text color="gray.300" mb={2}>
                {t('footer.joinTitle')}
              </Text>
              <Link to={routes.HOST} className="none">
                <Button colorScheme="white" size={['sm', 'def']} px={[6, 8, 10]} id="get-started">
                  {t('global.getStarted')}
                </Button>
              </Link>
              {/* <Box
                mt={6}
                textAlign={{ base: 'left', md: 'right' }}
                color="gray.300"
              >
                <label>{t('global.language')}</label>
                <LanguageSelect
                  variant="solid"
                  fontSize="sm"
                  ml={{ md: 'auto' }}
                  w={32}
                  bg="whiteAlpha.200"
                  size="xs"
                  mt={2}
                  sx={{ option: { color: 'initial' } }}
                />
              </Box> */}
            </Box>
          </Flex>
        </Flex>
        <Flex
          direction={{ base: 'column', lg: 'row' }}
          align={{ lg: 'center' }}
          justify="space-between"
          gap={2}
          my={2}
        >
          <div>
            <Flex
              direction={{ base: 'column', lg: 'row' }}
              gap={2}
              mr={{ base: 0, lg: 8 }}
              fontSize="sm"
            >
              <div>
                <Text flexShrink={0} as="span" fontWeight="bold" mr={6}>
                  © {commonConfig.company.name}, Inc.
                </Text>
                <Text fontSize={'2xs'} color={'gray.600'} mt={'-px'}>
                  v{version}
                </Text>
              </div>
              <Text as="span" color="red.200">
                {t('global.madeBy')}
              </Text>
            </Flex>
          </div>
          <Box textAlign={{ base: 'left', lg: 'right' }}>
            <ButtonGroup spacing={3} colorScheme="gray.900" variant="solid" size="xs">
              <SocialLinks links={socials} />
            </ButtonGroup>
          </Box>
        </Flex>
      </Container>
    </Box>
  );
};

export default Footer;
